export const UNIQUE_ENTITY_ERROR = "78166242-d781-45d5-9662-42d781a5d50b";
//# sourceMappingURL=ErrorCodes.js.map